<div class="certificates-for-insurance-form form-container ms-large-t service-form" #formContainer>
  <form
    *ngIf="reactiveForm && (formStatus === FormStatus.INITIAL || formStatus === FormStatus.ERROR)"
    [formGroup]="reactiveForm"
    [finFormErrorFocus]="reactiveForm"
    (ngSubmit)="onSubmit()"
  >
    <fcom-notification
      *ngIf="formStatus === FormStatus.ERROR"
      class="mr-medium-y"
      [layout]="NotificationLayout.BLOCK"
      [theme]="NotificationTheme.ALERT"
    >
      {{ 'SERVICE_FORMS.NTServiceForms.error.title' | finLocalization }}
    </fcom-notification>
    <p class="font-body-1 mr-large-b nordic-blue-900-text">
      {{ 'SERVICE_FORMS.NTServiceForms.mandatoryFields' | finLocalization }}
    </p>
    <div class="ms-xlarge-b">
      <fcom-radio-item-group
        [id]="CertificatesForInsuranceCompanyField.REASON_FOR_CERTIFICATE"
        [options]="formInputGroupOptions[CertificatesForInsuranceCompanyField.REASON_FOR_CERTIFICATE]"
        [parentForm]="reactiveForm"
        [controlName]="CertificatesForInsuranceCompanyField.REASON_FOR_CERTIFICATE"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.certificatesForInsuranceCompanyReason'"
      >
      </fcom-radio-item-group>
    </div>
    <div class="flex flex--row flex--wrap flex--space-between form-subgroup">
      <fcom-text-input
        [controlName]="CertificatesForInsuranceCompanyField.FIRST_NAME"
        [parentForm]="reactiveForm"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.firstName'"
      ></fcom-text-input>
      <fcom-text-input
        [controlName]="CertificatesForInsuranceCompanyField.LAST_NAME"
        [parentForm]="reactiveForm"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.lastName'"
      ></fcom-text-input>
      <fcom-text-input
        [controlName]="CertificatesForInsuranceCompanyField.EMAIL"
        [parentForm]="reactiveForm"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.email'"
      ></fcom-text-input>
      <fcom-text-input
        [controlName]="CertificatesForInsuranceCompanyField.PHONE"
        [parentForm]="reactiveForm"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.phoneNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.phoneNumber'"
      ></fcom-text-input>
      <fcom-text-input
        [controlName]="CertificatesForInsuranceCompanyField.BOOKING_REFERENCE"
        [parentForm]="reactiveForm"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.reservationNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.reservationNumber'"
      ></fcom-text-input>
      <fcom-text-input
        [controlName]="CertificatesForInsuranceCompanyField.TICKET_NUMBER"
        [parentForm]="reactiveForm"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.ticketNumber.placeholder'"
        [translationErrorPrefix]="'SERVICE_FORMS.NTServiceForms.fields.ticketNumber'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.ticketNumber'"
      ></fcom-text-input>
      <div
        class="unstyled"
        *ngIf="reactiveForm.get(CertificatesForInsuranceCompanyField.CONFIRM_SELF_CANCELLED_BOOKING).enabled"
      >
        <p class="font-body-1">
          {{ 'SERVICE_FORMS.NTServiceForms.certificatesForInsuranceCompany.disclaimer' | finLocalization }}
        </p>
        <fin-form-input-checkbox
          [attr.data-testid]="CertificatesForInsuranceCompanyField.CONFIRM_SELF_CANCELLED_BOOKING"
          [controlName]="CertificatesForInsuranceCompanyField.CONFIRM_SELF_CANCELLED_BOOKING"
          [parentForm]="reactiveForm"
          [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.confirmFlightsCancellation'"
        >
        </fin-form-input-checkbox>
      </div>
    </div>
    <fin-form-array
      *ngIf="reactiveForm.get(CertificatesForInsuranceCompanyField.FLIGHTS).enabled"
      [controlName]="CertificatesForInsuranceCompanyField.FLIGHTS"
      [formGroupConfig]="formGroupConfig[CertificatesForInsuranceCompanyField.FLIGHTS]"
      [id]="CertificatesForInsuranceCompanyField.FLIGHTS"
      [maxGroups]="6"
      [minGroups]="1"
      [parentForm]="reactiveForm"
      [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.flightNumber'"
    >
      <!-- Numbering for companions should start from 2. FormArray returns 0 index so that is why +2 is added here -->
      <ng-template let-parentFlightNumber="parentFormGroup" let-index="index">
        <div class="flex flex--row flex--space-between flex--wrap form-subgroup">
          <fin-datepicker
            [controlName]="CertificatesForInsuranceCompanyField.FLIGHT_DATE"
            [id]="'flightDate_' + (index + 1)"
            [maxDate]="maxDate"
            [minDate]="minDate"
            [parentForm]="parentFlightNumber"
            [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.flightDate.placeholder'"
            [theme]="DatepickerTheme.WEB_2"
            [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.flightDate'"
          ></fin-datepicker>
          <fcom-text-input
            [controlName]="CertificatesForInsuranceCompanyField.FLIGHT_NUMBER"
            [id]="'flightNumber_' + (index + 1)"
            [parentForm]="parentFlightNumber"
            [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.flightNumber.placeholder'"
            [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.flightNumber'"
          ></fcom-text-input>
        </div>
      </ng-template>
    </fin-form-array>
    <div class="flex flex--row flex--wrap flex--space-between form-subgroup">
      <fcom-text-input
        *ngIf="reactiveForm.get([CertificatesForInsuranceCompanyField.WORLD_TRACER_NUMBER]).enabled"
        [controlName]="CertificatesForInsuranceCompanyField.WORLD_TRACER_NUMBER"
        [parentForm]="reactiveForm"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.worldTracerNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.worldTracerNumber'"
      ></fcom-text-input>
    </div>
    <div class="ps-small-t align-right">
      <fcom-button
        [text]="'SERVICE_FORMS.NTServiceForms.submit' | finLocalization"
        [type]="ButtonType.SUBMIT"
      ></fcom-button>
    </div>
  </form>
  <!-- While initializing and sending -->
  <div *ngIf="formStatus === FormStatus.INITIALIZING || formStatus === FormStatus.LOADING" class="relative loader">
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
  <!-- Success view -->
  <div *ngIf="formStatus === FormStatus.COMPLETE">
    <h2>{{ 'SERVICE_FORMS.NTServiceForms.success.title' | finLocalization }}</h2>
    <p [innerHTML]="'SERVICE_FORMS.NTServiceForms.success.genericFormMessage' | finLocalization"></p>
  </div>
</div>
